// ./context/auditLog/auditLogReducer.js

const auditLogReducer = (state, { type, payload }) => {
    switch (type) {
        // ====================================================================
        // LOADING & ERROR HANDLING
        // ====================================================================
        
        case 'SET_LOADING':
            return {
                ...state,
                isLoading: payload,
                error: payload ? null : state.error
            };

        case 'SET_ERROR':
            return {
                ...state,
                error: payload,
                isLoading: false
            };

        // ====================================================================
        // ADD LOGS
        // ====================================================================

        case 'ADD_LOG':
            return {
                ...state,
                isLoading: false,
                error: null
            };

        // ====================================================================
        // GET LOGS
        // ====================================================================

        case 'SET_STUDENT_LOGS':
            return {
                ...state,
                studentLogs: payload,
                isLoading: false,
                error: null
            };

        case 'SET_ENTITY_LOGS':
            return {
                ...state,
                entityLogs: payload,
                isLoading: false,
                error: null
            };

        case 'SET_USER_ACTIVITY':
            return {
                ...state,
                userActivity: payload,
                isLoading: false,
                error: null
            };

        case 'SET_LOGS_BY_ACTION':
            return {
                ...state,
                logsByAction: payload,
                isLoading: false,
                error: null
            };

        // ====================================================================
        // SECURITY & MONITORING
        // ====================================================================

        case 'SET_SECURITY_EVENTS':
            return {
                ...state,
                securityEvents: payload,
                isLoading: false,
                error: null
            };

        case 'SET_FAILED_LOGINS':
            return {
                ...state,
                failedLogins: payload,
                isLoading: false,
                error: null
            };

        case 'SET_CRITICAL_EVENTS':
            return {
                ...state,
                criticalEvents: payload,
                isLoading: false,
                error: null
            };

        // ====================================================================
        // REPORTING & ANALYTICS
        // ====================================================================

        case 'SET_COMPLIANCE_REPORT':
            return {
                ...state,
                complianceReport: payload,
                isLoading: false,
                error: null
            };

        case 'SET_SYSTEM_ACTIVITY':
            return {
                ...state,
                systemActivity: payload,
                isLoading: false,
                error: null
            };

        case 'SET_STATISTICS':
            return {
                ...state,
                statistics: payload,
                isLoading: false,
                error: null
            };

        case 'SET_SEARCH_RESULTS':
            return {
                ...state,
                searchResults: payload,
                isLoading: false,
                error: null
            };

        // ====================================================================
        // UTILITY
        // ====================================================================

        case 'CLEAR_AUDIT_LOG_DATA':
            return {
                studentLogs: [],
                entityLogs: [],
                userActivity: [],
                logsByAction: [],
                securityEvents: [],
                failedLogins: [],
                criticalEvents: [],
                complianceReport: null,
                systemActivity: null,
                statistics: null,
                searchResults: [],
                isLoading: false,
                error: null
            };

        default:
            return state;
    }
};

export default auditLogReducer;